import { IFacilityReitItem } from "..";
import { toReadablePrice } from "../../../../../../lib/utils";
import DottedList from "../../../../../ui/dottedList";
import styles from "./styles.module.scss";

const IMG_NOT_FOUND_PLAN = "../img/notfoundPlan.jpg";

interface IFacilityItem extends IFacilityReitItem {
  onClick: (value: number, offsetY: number) => void;
}

const FacilityItem = ({
  title,
  img,
  price,
  address,
  id,
  onClick,
}: IFacilityItem) => {
  const titleSplitted = title.split(",");
  return (
    <div
      className={styles.facilityItem}
      onClick={(event) => onClick(id, event.pageY)}
    >
      <div className={styles.facilityItem__container}>
        <div className={styles.facilityItem__left}>
          <div className={styles.facilityItem__img}>
            <img src={img.url ?? IMG_NOT_FOUND_PLAN} alt={img.name ?? "img"} />
          </div>
        </div>
        <div className={styles.facilityItem__right}>
          <div className={styles.facilityItem__type}>
            <DottedList items={[{ label: "Тип", value: titleSplitted[0] }]} />
          </div>
          <div className={styles.facilityItem__area}>
            <DottedList
              items={[{ label: "Площадь", value: titleSplitted[1] }]}
            />
          </div>
          <div className={styles.facilityItem__flor}>
            <DottedList items={[{ label: "Этаж", value: titleSplitted[2] }]} />
          </div>
          <div className={styles.facilityItem__price}>
            <DottedList
              items={[{ label: "Цена", value: toReadablePrice(price) }]}
            />
          </div>
          <div className={styles.facilityItem__button}>
            <u>Посмотреть</u>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FacilityItem;
